import { KeyboardEvent, MouseEvent, cloneElement } from 'react'
import { SwipeableDrawer } from '@mui/material'
import { BaseProps } from '@/components/types'

function SwipeableMenu ( props: SwipeableMenuProps ) {
    const {
        anchor, open, setOpen,
        children
    } = props

    const toggleDrawer = ( open: boolean ) =>
        ( event: KeyboardEvent | MouseEvent ) => {
            const { type } = event
            const { key } = event as KeyboardEvent
            if ( event && type === 'keydown' && key === 'Tab' ) {
                return
            }
            setOpen( open )
        }

    return (
        <div>
            {
                <>
                    <SwipeableDrawer
                        anchor={ anchor }
                        open={ open }
                        onClose={ toggleDrawer( false ) }
                        onOpen={ toggleDrawer( true ) }
                    >
                        { children && cloneElement( children, { setOpen } ) }
                    </SwipeableDrawer>
                </>
            }
        </div>
    )
}

export default SwipeableMenu

type Anchor = 'top' | 'left' | 'bottom' | 'right'

export interface SwipeableMenuProps extends BaseProps  {
    anchor: Anchor
    open: boolean
    setOpen: Function
}